module.exports = __webpack_public_path__ + "static/media/brotregal.5288a7bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/brotregal.png
// module id = 492
// module chunks = 0